import React, {PureComponent} from 'react';
import TranslatedText from './TranslatedText';

import './HowItWorksLabel.css';

export default class HowItWorksLabel extends PureComponent {
    state = {
        active: false,
    };

    handleLabel = () => {
        this.setState({
            active: !this.state.active,
        });
    };

    render() {
        const active = this.state.active ? ' HowItWorksLabel-active' : '';
        const labelClass =
            'HowItWorksLabel HowItWorksLabel-' + this.props.index + active;

        return (
            <div className={labelClass} onClick={this.handleLabel}>
                <div className="HowItWorksLabel-number">
                    {this.props.index + 1}
                </div>
                <div className="HowItWorksLabel-label">
                    <TranslatedText tag={this.props.label} />
                </div>
                <div className="HowItWorksLabel-full">
                    <TranslatedText tag={this.props.labelFull} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/atoms/HowItWorksLabel.js